/* eslint-disable class-methods-use-this */
import type { Nullable } from '../types';
import type { SecretManager } from './secretManager';

export default class SecretManagerImpl implements SecretManager {
  get recommendationBackendUrl(): string {
    const url: Nullable<string> =
      process.env.REACT_APP_RECOMMENDATIONS_BACKEND_URL;

    if (!url) {
      throw Error(
        'REACT_APP_RECOMMENDATIONS_BACKEND_URL variable is missing in your environment file.'
      );
    }

    return url;
  }

  get clientID(): string {
    const id: Nullable<string> = process.env.REACT_APP_CLIENT_ID;

    if (!id) {
      throw Error(
        'REACT_APP_CLIENT_ID variable is missing in your environment file.'
      );
    }

    return id;
  }

  get googleClientId(): string {
    const googleClientId: Nullable<string> =
      process.env.REACT_APP_GOOGLE_CLIENT_ID;

    if (!googleClientId) {
      throw Error(
        'REACT_APP_GOOGLE_CLIENT_ID variable is missing in your environment file.'
      );
    }

    return googleClientId;
  }

  get facebookClientId(): string {
    const facebookClientId: Nullable<string> =
      process.env.REACT_APP_FACEBOOK_CLIENT_ID;

    if (!facebookClientId) {
      throw Error(
        'REACT_APP_FACEBOOK_CLIENT_ID variable is missing in your environment file.'
      );
    }

    return facebookClientId;
  }

  get iubendaApiKey(): string {
    const apiKey: Nullable<string> = process.env.REACT_APP_IUBENDA_API_KEY;

    if (!apiKey) {
      throw Error(
        'REACT_APP_IUBENDA_API_KEY variable is missing in your environment file.'
      );
    }

    return apiKey;
  }

  get gtmId(): string {
    const gtmId: Nullable<string> = process.env.REACT_APP_GTM_ID;

    if (!gtmId) {
      throw Error(
        'REACT_APP_GTM_ID variable is missing in your environment file.'
      );
    }
    return gtmId;
  }

  get gtmAuth(): string {
    const gtmAuth: Nullable<string> = process.env.REACT_APP_GTM_AUTH;

    if (!gtmAuth) {
      throw Error(
        'REACT_APP_GTM_AUTH variable is missing in your environment file.'
      );
    }
    return gtmAuth;
  }

  get gtmPreview(): string {
    const gtmPreview: Nullable<string> = process.env.REACT_APP_GTM_PREVIEW;

    if (!gtmPreview) {
      throw Error(
        'REACT_APP_GTM_PREVIEW variable is missing in your environment file.'
      );
    }
    return gtmPreview;
  }

  get s3BucketUrl(): string {
    const url: Nullable<string> = process.env.REACT_APP_S3_BUCKET_URL;

    if (!url) {
      throw Error(
        'REACT_APP_S3_BUCKET_URL variable is missing in your environment file.'
      );
    }

    return url;
  }

  get salesEmail(): string {
    const salesEmail: Nullable<string> = process.env.REACT_APP_SALES_EMAIL;

    if (!salesEmail) {
      throw Error(
        'REACT_APP_SALES_EMAIL variable is missing in your environment file.'
      );
    }

    return salesEmail;
  }

  get sentryDsn(): string {
    const dsn: Nullable<string> = process.env.REACT_APP_SENTRY_DSN;

    if (!dsn) {
      throw Error(
        'REACT_APP_SENTRY_DSN variable is missing in your environment file.'
      );
    }

    return dsn;
  }

  get turnstileSiteKey(): string {
    const siteKey: Nullable<string> =
      process.env.REACT_APP_CLOUDFLARE_TURNSTILE_SITE_KEY;

    if (!siteKey) {
      throw Error(
        'REACT_APP_CLOUDFLARE_TURNSTILE_SITE_KEY variable is missing in your environment file.'
      );
    }

    return siteKey;
  }

  get releaseTag() {
    return process.env.REACT_APP_RELEASE_TAG;
  }

  get loudlyDomain() {
    const loudlyDomainurl = process.env.REACT_APP_LOUDLY_DOMAIN;

    if (!loudlyDomainurl) {
      throw Error(
        'REACT_APP_LOUDLY_DOMAIN variable is missing in your environment file.'
      );
    }
    return loudlyDomainurl;
  }

  get chatBotUrl(): string {
    const url: Nullable<string> = process.env.REACT_APP_CHAT_BOT_URL;

    if (!url) {
      throw Error(
        'REACT_APP_CHAT_BOT_URL variable is missing in your environment file.'
      );
    }
    return url;
  }

  get chatBotID(): string {
    const id: Nullable<string> = process.env.REACT_APP_CHAT_BOT_ID;

    if (!id) {
      throw Error(
        'REACT_APP_CHAT_BOT_ID variable is missing in your environment file.'
      );
    }
    return id;
  }
}
